import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-burger",
  "use": "spr-burger-usage",
  "viewBox": "0 0 24 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 20\" id=\"spr-burger\"><defs><path id=\"spr-burger_a\" d=\"M40 121H16v-2h24zm0-9H16v-2h24zm-8 18H16v-2h16z\" /></defs><use fill=\"#cd9932\" xlink:href=\"#spr-burger_a\" transform=\"translate(-16 -110)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/burger.svg
// module id = 245
// module chunks = 0